import BaseStore from '@/store/baseStore'
import BaseRevisionStore from '@/store/baseRevisionStore'

export const namespaced = true

const baseURI = '/stage_configuration_revision/'

const baseStore = new BaseStore(baseURI)
const baseRevisionStore = new BaseRevisionStore(baseURI)

const getDefaultState = () => {
  return {
    ...structuredClone(baseStore.state),
    ...structuredClone(baseRevisionStore.state),
    fields: ['name', 'x_max', 'x_min', 'z_max', 'z_min']
  }
}

export const state = getDefaultState()

export const mutations = {
  ...baseStore.mutations,
  ...baseRevisionStore.mutations,
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  }
}
export const actions = {
  ...baseStore.actions,
  ...baseRevisionStore.actions,
  resetState({ commit }) {
    commit('RESET_STATE')
  }
}

export const getters = {
  ...baseRevisionStore.getters,
  hasStabSchematisation: (state) => {
    return state.selectedRevision?.has_stab_schematisation_check
  },
  hasStabSchematisationById: (state, getters, rootState, rootGetters) => (id) => {
    const revisionSet = rootGetters['project/getRevisionSet']('stageconfigurationrevision_set')
    const revision = revisionSet.find((revision) => revision.id === id)
    return revision?.has_stab_schematisation_check
  }
}
